import React, { useCallback, useEffect, useState } from "react";
import { Card, Typography, Menu, Divider, Tooltip } from "antd";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
// import SecondaryNav from "../../../components/AdminComponents/SecondaryNav2";
import {
  CourseTopLevelCA,
  // TraineryLearnCaEdit,
  CourseTopLevel,
  // TraineryLearnEdit,
} from "../../../components/AdminComponents/MenuItems";
import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import {
  FileTextOutlined,
  ReadOutlined,
  AppstoreOutlined,
  BranchesOutlined,
  TeamOutlined,
  PartitionOutlined,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import { useLocation, useParams } from "react-router-dom";
import "./courseStyles.css";

import CourseSummary from "./CourseEditTabs/CourseSummary";
import CourseContent from "./CourseEditTabs/CourseContent";
import CourseUsers from "./CourseEditTabs/CourseUsers";
import Bundles from "./CourseEditTabs/Bundles";
import Departments from "./CourseEditTabs/Departments";
import CourseClients from "./CourseEditTabs/CourseClients";
import axiosInstance from "../../../api/Axios";
import CourseEditRightBar from "./CourseEditTabs/CourseEditRightBar";
import CourseTrainers from "./CourseEditTabs/CourseTrainers";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { accessImpersontate } from "../../../config";
import { useSelector } from "react-redux";
const { Title } = Typography;

const CourseEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const [activeView, setActiveView] = useState("summary");
  const [currentMode, setCurrentMode] = useState(null);
  const [data1, setData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const isVirtualOrOnsite =
    currentMode === "Virtual" || currentMode === "Onsite";
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Course Summary</div>
        </div>
      ),
    },
    {
      key: "content",
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <ReadOutlined style={{ fontSize: "22px" }} />
            {data1?.coursedetails_count > 0 && (
              <span className="department-count-badge">
                {data1?.coursedetails_count}
              </span>
            )}
          </span>
          <div>Course Content</div>
        </div>
      ),
    },
    isCAAdmin && {
      key: "bundle",
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <AppstoreOutlined style={{ fontSize: "22px" }} />
            {data1?.bundle_count > 0 && (
              <span className="department-count-badge">
                {data1?.bundle_count}
              </span>
            )}
          </span>
          <div>Bundles</div>
        </div>
      ),
    },
    isCAAdmin && {
      key: isVirtualOrOnsite ? "trainers" : "users",
      disabled:
        currentMode === "E-Learning" && data1?.coursedetails_count === 0,
      label: (
        <Tooltip
          title={
            isVirtualOrOnsite && data1?.course_user_count === 0
              ? "Please add at least one trainer to make this course available for selection in events"
              : currentMode === "E-Learning" && data1?.coursedetails_count === 0
              ? "Please add at least one content to make this course available for user assignment"
              : ""
          }
        >
          <div className={`menu-vertical-item`}>
            <span style={{ display: "flex", alignItems: "center" }}>
              <TeamOutlined
                style={{
                  fontSize: "22px",
                  color:
                    currentMode === "E-Learning" &&
                    data1?.coursedetails_count === 0
                      ? "gray"
                      : "",
                }}
              />
              {isVirtualOrOnsite && data1?.course_user_count === 0 ? (
                <ExclamationCircleTwoTone
                  style={{ fontSize: "22px" }}
                  twoToneColor="orange"
                />
              ) : currentMode === "E-Learning" &&
                data1?.coursedetails_count === 0 ? (
                <ExclamationCircleTwoTone
                  style={{ fontSize: "22px" }}
                  twoToneColor="orange"
                />
              ) : (
                data1?.course_user_count > 0 && (
                  <span className="department-count-badge">
                    {data1?.course_user_count}
                  </span>
                )
              )}
            </span>
            <div>{isVirtualOrOnsite ? "Trainers" : "Users"}</div>
          </div>
        </Tooltip>
      ),
    },

    isCAAdmin &&
      false && {
        key: "department",
        label: (
          <div className="menu-vertical-item">
            <span style={{ display: "flex", alignItems: "center" }}>
              <BranchesOutlined style={{ fontSize: "22px" }} />
              {/* <span className="department-count-badge">10</span> */}
            </span>
            <div style={{ display: "inline-block" }}>Departments</div>
          </div>
        ),
      },
    !isCAAdmin && {
      key: "clients",
      label: (
        <div className="menu-vertical-item">
          <span style={{ display: "flex", alignItems: "center" }}>
            <PartitionOutlined style={{ fontSize: "22px" }} />
            {data1?.client_count > 0 && (
              <span className="department-count-badge">
                {data1?.client_count}
              </span>
            )}
          </span>
          <div style={{ display: "inline-block" }}>Clients</div>
        </div>
      ),
    },
  ];

  const LoadUser = useCallback(async () => {
    try {
      const res = await axiosInstance.get(`/courselist/${id}/`);
      setData1(res.data);
      setCurrentMode(res.data.mode);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    LoadUser();
  }, [LoadUser]);
  const userInfo = useSelector((state) => state.user);
  // Original code - commented out to allow access in production when impersonating
  // const ImpersonateAccess = !accessImpersontate(
  //   userInfo?.data?.impersonate_acc
  // );
  // Always allow access for Courses section
  const ImpersonateAccess = true;
  const sharedProps = {
    data1,
    loading,
    LoadUser,
    ImpersonateAccess,
    isCAAdmin,
  };
  const renderActiveView = () => {
    switch (activeView) {
      case "summary":
        return <CourseSummary {...sharedProps} />;
      case "content":
        return <CourseContent {...sharedProps} />;
      case "bundle":
        return <Bundles {...sharedProps} />;
      case "users":
        return <CourseUsers {...sharedProps} />;
      case "trainers":
        return <CourseTrainers {...sharedProps} />;
      case "department":
        return <Departments {...sharedProps} />;
      case "clients":
        return <CourseClients {...sharedProps} />;
      default:
        return <CourseSummary {...sharedProps} />;
    }
  };
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  return (
    <WrapperComponent props={wrapperProps}>
      {/* <SecondaryNav
        menuItems={isCAAdmin ? TraineryLearnCaEdit(id) : TraineryLearnEdit(id)}
      /> */}

      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Edit Course
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex", overflowX: "auto" }}>
          {renderActiveView()}
        </div>
        <div style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}>
          <CourseEditRightBar
            data1={data1}
            loading={loading}
            LoadUser={LoadUser}
            ImpersonateAccess={ImpersonateAccess}
            isCAAdmin={isCAAdmin}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CourseEdit;
